import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, ArrowRight } from 'lucide-react';
import { fadeInUp, staggerContainer, slideInRight } from '../lib/animations';
export function Contact() {
  return <section id="contact" className="py-24 md:py-32 bg-white" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} className="text-center mb-20" data-id="element-32">
          <motion.span variants={fadeInUp} className="text-[#dc2626] font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-33">
            Get In Touch
          </motion.span>
          <motion.h2 variants={fadeInUp} className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6" data-id="element-34">
            Start Your Project With Us
          </motion.h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-20" data-id="element-35">
          {/* Contact Info */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} className="lg:col-span-1 space-y-8" data-id="element-36">
            {[{
            icon: <MapPin className="w-6 h-6" data-id="element-37" />,
            title: 'Visit Our Office',
            content: '70 Ramwadi, Jay Jagruti Niwas, 2nd Floor, Room No.24, Cavel Cross Lane no. 3, Kalbadevi Road, Mumbai - 400002'
          }, {
            icon: <Phone className="w-6 h-6" data-id="element-38" />,
            title: 'Call Us',
            content: '+91-9870622203',
            link: 'tel:+919870622203',
            sub: 'Aditya Darak'
          }, {
            icon: <Mail className="w-6 h-6" data-id="element-39" />,
            title: 'Email Us',
            content: 'shivaayfashions9@gmail.com',
            link: 'mailto:shivaayfashions9@gmail.com'
          }].map((item, index) => <motion.div key={index} variants={fadeInUp} className="flex items-start space-x-5 p-6 rounded-2xl bg-gray-50 hover:bg-blue-50 transition-colors duration-300 group" data-id="element-40">
                <div className="flex-shrink-0 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm text-[#1e3a8a] group-hover:bg-[#1e3a8a] group-hover:text-white transition-all duration-300" data-id="element-41">
                  {item.icon}
                </div>
                <div data-id="element-42">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-43">{item.title}</h3>
                  {item.link ? <a href={item.link} className="text-gray-600 hover:text-[#1e3a8a] transition-colors block" data-id="element-44">
                      {item.content}
                    </a> : <p className="text-gray-600 text-sm leading-relaxed" data-id="element-45">
                      {item.content}
                    </p>}
                  {item.sub && <p className="text-sm text-gray-500 mt-1" data-id="element-46">{item.sub}</p>}
                </div>
              </motion.div>)}
          </motion.div>

          {/* Contact Form */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={slideInRight} className="lg:col-span-2" data-id="element-47">
            <form action="https://formsubmit.co/vishaldarak879@gmail.com" method="POST" className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_0_50px_rgba(0,0,0,0.05)] border border-gray-100" data-id="element-48">
              {/* FormSubmit Configuration - Hidden Fields */}
              <input type="hidden" name="_cc" value="shivaayfashions9@gmail.com" data-id="element-49" />
              <input type="hidden" name="_subject" value="New Inquiry from Shivaay Fashion Website" data-id="element-50" />
              <input type="hidden" name="_captcha" value="false" data-id="element-51" />
              <input type="hidden" name="_template" value="table" data-id="element-52" />
              <input type="hidden" name="_next" value="https://shivaayfashions.in/#contact" data-id="element-53" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-54">
                <div className="space-y-2" data-id="element-55">
                  <label htmlFor="name" className="text-sm font-medium text-gray-700" data-id="element-56">
                    Full Name *
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#1e3a8a] focus:bg-white outline-none transition-all duration-300 rounded-t-lg" placeholder="John Doe" data-id="element-57" />
                </div>
                <div className="space-y-2" data-id="element-58">
                  <label htmlFor="phone" className="text-sm font-medium text-gray-700" data-id="element-59">
                    Phone Number *
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#1e3a8a] focus:bg-white outline-none transition-all duration-300 rounded-t-lg" placeholder="+91..." data-id="element-60" />
                </div>
              </div>

              <div className="space-y-2 mb-8" data-id="element-61">
                <label htmlFor="email" className="text-sm font-medium text-gray-700" data-id="element-62">
                  Email Address *
                </label>
                <input type="email" id="email" name="email" required className="w-full px-4 py-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#1e3a8a] focus:bg-white outline-none transition-all duration-300 rounded-t-lg" placeholder="john@company.com" data-id="element-63" />
              </div>

              <div className="space-y-2 mb-8" data-id="element-64">
                <label htmlFor="interest" className="text-sm font-medium text-gray-700" data-id="element-65">
                  Interested In
                </label>
                <select id="interest" name="interest" className="w-full px-4 py-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#1e3a8a] focus:bg-white outline-none transition-all duration-300 rounded-t-lg" data-id="element-66">
                  <option value="" data-id="element-67">Select a product category</option>
                  <option value="fabrics" data-id="element-68">Fabrics / Raw Material</option>
                  <option value="sarees" data-id="element-69">Sarees</option>
                  <option value="garments" data-id="element-70">Readymade Garments</option>
                  <option value="export" data-id="element-71">Export Inquiry</option>
                  <option value="other" data-id="element-72">Other</option>
                </select>
              </div>

              <div className="space-y-2 mb-10" data-id="element-73">
                <label htmlFor="message" className="text-sm font-medium text-gray-700" data-id="element-74">
                  Message *
                </label>
                <textarea id="message" name="message" required rows={4} className="w-full px-4 py-4 bg-gray-50 border-b-2 border-gray-200 focus:border-[#1e3a8a] focus:bg-white outline-none transition-all duration-300 rounded-t-lg resize-none" placeholder="Tell us about your requirements..." data-id="element-75"></textarea>
              </div>

              <motion.button type="submit" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="w-full md:w-auto px-10 py-4 bg-[#1e3a8a] text-white font-bold rounded-full shadow-lg hover:shadow-xl hover:bg-[#152c6b] transition-all duration-300 flex items-center justify-center" data-id="element-76">
                Send Message <ArrowRight className="ml-2 w-5 h-5" data-id="element-77" />
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}